<template>
  <div class="tan px_kcadd">
    <div class="px_add_con">
      <div class="rdiv">
        <h3>预览证书</h3>
        <a href="javascript:void(0);" class="close" @click="$emit('close')"></a>
        <div style="position: relative; height: 450px; overflow: scroll; text-align: center;">
          <img id="pic" :src="form.url" :width="form.width" :height="form.height">
          <div style="position: relative;" :style="{top: -form.height + 'px'}">
            <label v-for="item in form.certTemplatePointLoactionList" v-if="item.pointValue" :key="item.pointKey" :data-key="item.pointKey" :data-value="item.pointValue" :data-label="item.pointLabel" :style="{left: item.localX + 'px', top: (item.localY - tagHeight) + 'px'}" class="drag" style="position: absolute">
              <span :style="{fontSize: JSON.parse(item.certFont).size + 'px', fontFamily: JSON.parse(item.certFont).fontName, color: getColor(JSON.parse(item.certFont)) }">{{item.pointValue}}</span>
            </label>
          </div>
        </div>
      </div>
      <div class="clear"></div>
    </div>
  </div>
</template>

<script>
  import config from '@/config'
  import api from '@/api'
  import Bus from '@/utils/bus'
  export default {
    mounted () {
      this.getModel(this.id)
    },
    computed: {
    },
    data () {
      return {
        tagHeight: 26,
        form: {}
      }
    },
    props: ['id', 'p'],
    methods: {
      getModel (id) {
        var that = this
        api.post(config.certApiPath, '/cert-instances/' + id, this.p, function (r) { // 正常
          that.form = r.data
        })
      },
      getColor (item) {
        return 'rgba(' + item.colorR + ',' + item.colorG + ',' + item.colorB + ',' + '1' + ')'
      }
    }
  }
</script>

<style scoped>
  .drag {
    min-width: 40px;
    height: 30px;
    text-align: center;
    line-height: 30px;
    padding: 0 1px;
    font-size: 18px;
    color: #000;
    z-index: 6;
  }
</style>



// WEBPACK FOOTER //
// src/page/byl/org/cert/view.vue